import { createContext } from 'react';
import { Event, Player } from '../../type';

type eventContext = {
    event?: Event,
    self?: Player
};

export default createContext<eventContext>({});